import React from 'react';
import AppBox from '@/components/AppBox';
import AppButton from '@/components/AppButton';
import AppCard from '@/components/AppCard';
import AppText from '../AppText';

import { Lead } from '@/types';
import AppTooltip from '@/components/AppTooltip';
import { tooltipTitles } from '@/constants/tooltipTitles';
import AppIcon from '@/components/AppIcon';

interface ChangeLeadStatusProps {
  lead: Lead;
  onStatusChange: (status: string) => void;
}

const ChangeLeadStatus: React.FC<ChangeLeadStatusProps> = ({ lead, onStatusChange }) => {
  if (lead?.type === 'Missed Call') {
    return null;
  }

  return (
    <AppCard className='gap-4 h-auto'>
      <AppBox fullWidth align="center" gap={2}>
        <AppText variant="h4">Change Status</AppText>
        <AppTooltip title={tooltipTitles.leadChangeStatus}>
          <AppIcon name="help" size={16} />
        </AppTooltip>
      </AppBox>
      {
        !lead?.lsaStatus
          ? <AppBox fullWidth gap={2}>
              <AppButton 
                className="text-sm py-0" 
                onClick={() => onStatusChange('archived')}
              >
                Lead Archived
              </AppButton>
      
              <AppButton 
                className="text-sm py-0" 
                onClick={() => onStatusChange('booked')}
              >
                Lead Booked
              </AppButton>
            </AppBox>
          : <AppText variant="body1" className="capitalize">{lead?.lsaStatus}</AppText>
      }
    </AppCard>
  );
};

export default ChangeLeadStatus;
